import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAdjust, faTextHeight } from '@fortawesome/free-solid-svg-icons'
import useLocalStorage from 'react-use-localstorage'
import './accessibility-toggles.css'

export const TOGGLE_KEY_LARGE_TEXT = 'largeText'
export const TOGGLE_KEY_HIGH_CONTRAST = 'highContrast'

export function AccessibilityToggle({
  toggleKey,
  tooltip,
  onToggle,
  children,
}: {
  toggleKey: string
  tooltip: string
  onToggle: Function
  children: React.ReactNode
}) {
  let toggleValue = 'false'
  let setToggleValue = (newValue: string) => {}
  if (typeof window !== `undefined`) {
    ;[toggleValue, setToggleValue] = useLocalStorage(toggleKey, 'false')
  }
  return (
    <button
      className={`accessibility-toggle accessibility-toggle-${toggleValue}`}
      title={tooltip}
      onClick={() => {
        const newToggle = toggleValue === 'false'
        setToggleValue(`${newToggle}`)
        onToggle(newToggle)
      }}
    >
      {children}
    </button>
  )
}
